import request from '@/utils/request'

//投标人获取群聊列表接口


export const getEvaluationRoomList = (data) => {
    return request.get('/api/chat/bidder/group',data)
} 


// 专家获取群聊列表接口
export const getExpertGroupList = () => {
  return request.get('/api/chat/evaluation/group')
}

// 发送消息接口
export const sendMessage = (data) => {
  return request.post('/api/chat/msg/send', data)
}
//获取聊天记录接口
export const getChatList = (groupId) => {
  return request.get('/api/chat/msg/list?groupId='+groupId)
}

//开标大厅聊天记录
export const getDecryptChatList = (groupId) => {
    return request.get('/api/chat/msg/decrypt/list?groupId='+groupId)
}


